import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  HOMEPAGE_CLEAR_DATA,
  HOMEPAGE_SELECT_LANGUAGE,
  HOMEPAGE_DATA_FETCH,
  HOMEPAGE_DATA_SUCCESS,
  HOMEPAGE_DATA_FAILURE,
  UPDATE_HOMEPAGE_DATA_FETCH,
  UPDATE_HOMEPAGE_DATA_SUCCESS,
  UPDATE_HOMEPAGE_DATA_FAILURE
} from './actionTypes';
import { batchActions } from 'redux-batched-actions';
import { change } from 'redux-form';
import { HP_SETTINGS_FORM_NAME } from './constants';

//<<<---CLEAR-DATA--->>>
export const clearData = createAction(HOMEPAGE_CLEAR_DATA);

//<<<---SELECT_LANGUAGE--->>>
export const selectLangugeAction = createAction(HOMEPAGE_SELECT_LANGUAGE);

export const selectLanguge = lang => dispatch => {
  dispatch(clearData());
  dispatch(selectLangugeAction(lang));
  dispatch(fetchHomepageData(lang));
};

//<<<---FETCH-HOMEPAGE-DATA--->>>
export const homepageDataFetch = createAction(HOMEPAGE_DATA_FETCH);
export const homepageDataSuccess = createAction(HOMEPAGE_DATA_SUCCESS);
export const homepageDataFailure = createAction(HOMEPAGE_DATA_FAILURE);

export const fetchHomepageData = lang => async dispatch => {
  dispatch(homepageDataFetch());
  try {
    const res = await api.get(`homepage/${lang}`);

    const { data } = res;

    const updateFormValues = [
        change(HP_SETTINGS_FORM_NAME, 'title', data.title),
        change(HP_SETTINGS_FORM_NAME, 'description', data.description),
        change(HP_SETTINGS_FORM_NAME, 'slug', data.slug),
        change(HP_SETTINGS_FORM_NAME, 'image', data.image),
        change(HP_SETTINGS_FORM_NAME, 'header', data.header),
        change(HP_SETTINGS_FORM_NAME, 'subtitle', data.subtitle),
    ];

    dispatch(batchActions(updateFormValues));
    dispatch(homepageDataSuccess());
  } catch (error) {
    dispatch(homepageDataFailure(error));
  }
};

//<<<---UPDATE-HOMEPAGE-DATA--->>>
export const updateHomepageDataFetch = createAction(UPDATE_HOMEPAGE_DATA_FETCH);
export const updateHomepageDataSuccess = createAction(
  UPDATE_HOMEPAGE_DATA_SUCCESS
);
export const updateHomepageDataFailure = createAction(
  UPDATE_HOMEPAGE_DATA_FAILURE
);

export const updateHomepageData = (formData, lang) => async dispatch => {
  dispatch(updateHomepageDataFetch());
  try {
    const res = await api.post(`homepage/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    dispatch(clearData());
    dispatch(updateHomepageDataSuccess(data));
  } catch (error) {
    dispatch(updateHomepageDataFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/actions.js